import React, { useEffect, useState } from "react";
//Bootstrap
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import InputGroup from "react-bootstrap/InputGroup";
//Fontawesome
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash, faPlus } from "@fortawesome/free-solid-svg-icons";

export default function ExpensesTableRows({
  id,
  row,
  addRow,
  removeRow,
  setField,
  expenseRows,
}) {
  const [show, setShow] = useState(false);
  useEffect(() => {
    if (row.id === expenseRows[expenseRows.length - 1].id) {
      setShow(true);
    } else {
      setShow(false);
    }
  }, [expenseRows]);
  return (
    <tr key={id}>
      <td>
        <Form.Group>
          <InputGroup size="sm">
            <Form.Control
              type="text"
              className="expensesTableInput"
              placeholder="Title"
              value={row.title}
              onChange={(e) => setField("title", id, e.target.value)}
            />
          </InputGroup>
        </Form.Group>
      </td>
      <td>
        <Form.Group>
          <InputGroup size="sm">
            <InputGroup.Text className="expensesTableInputGroup">
              £
            </InputGroup.Text>
            <Form.Control
              type="number"
              step="any"
              className="expensesTableInput"
              value={row.expenseOne === 0 ? undefined : row.expenseOne}
              placeholder="Amt"
              onChange={(e) => setField("expenseOne", id, e.target.value)}
            />
          </InputGroup>
        </Form.Group>
      </td>
      <td>
        <Form.Group>
          <InputGroup size="sm">
            <InputGroup.Text className="expensesTableInputGroup">
              £
            </InputGroup.Text>
            <Form.Control
              type="number"
              step="any"
              className="expensesTableInput"
              value={row.expenseTwo === 0 ? undefined : row.expenseTwo}
              placeholder="Amt"
              onChange={(e) => setField("expenseTwo", id, e.target.value)}
            />
          </InputGroup>
        </Form.Group>
      </td>
      <td>
        <Form.Group>
          <InputGroup size="sm">
            <InputGroup.Text className="expensesTableInputGroup">
              £
            </InputGroup.Text>
            <Form.Control
              type="number"
              step="any"
              className="expensesTableInput"
              value={row.expenseThree === 0 ? undefined : row.expenseThree}
              placeholder="Amt"
              onChange={(e) => setField("expenseThree", id, e.target.value)}
            />
          </InputGroup>
        </Form.Group>
      </td>
      <td>
        <Form.Group>
          <InputGroup size="sm">
            <InputGroup.Text className="expensesTableInputGroup">
              £
            </InputGroup.Text>
            <Form.Control
              type="number"
              step="any"
              className="expensesTableInput"
              value={row.expenseFour === 0 ? undefined : row.expenseFour}
              placeholder="Amt"
              onChange={(e) => setField("expenseFour", id, e.target.value)}
            />
          </InputGroup>
        </Form.Group>
      </td>
      <td>
        <Form.Group>
          <InputGroup size="sm">
            <InputGroup.Text className="expensesTableInputGroup">
              £
            </InputGroup.Text>
            <Form.Control
              type="number"
              step="any"
              className="expensesTableInput"
              value={row.expenseFive === 0 ? undefined : row.expenseFive}
              placeholder="Amt"
              onChange={(e) => setField("expenseFive", id, e.target.value)}
            />
          </InputGroup>
        </Form.Group>
      </td>
      <td>
        <Form.Group>
          <InputGroup size="sm">
            <InputGroup.Text className="expensesTableInputGroup">
              £
            </InputGroup.Text>
            <Form.Control
              type="number"
              step="any"
              className="expensesTableInput"
              value={row.expenseSix === 0 ? undefined : row.expenseSix}
              placeholder="Amt"
              onChange={(e) => setField("expenseSix", id, e.target.value)}
            />
          </InputGroup>
        </Form.Group>
      </td>
      <td>
        <Form.Group>
          <InputGroup size="sm">
            <InputGroup.Text className="expensesTableInputGroup">
              £
            </InputGroup.Text>
            <Form.Control
              type="number"
              step="any"
              className="expensesTableInput"
              value={row.expenseSeven === 0 ? undefined : row.expenseSeven}
              placeholder="Amt"
              onChange={(e) => setField("expenseSeven", id, e.target.value)}
            />
          </InputGroup>
        </Form.Group>
      </td>
      <td>
        <Form.Group>
          <InputGroup size="sm">
            <InputGroup.Text className="expensesTableInputGroup">
              £
            </InputGroup.Text>
            <Form.Control
              type="number"
              step="any"
              className="expensesTableInput"
              value={row.expenseEight === 0 ? undefined : row.expenseEight}
              placeholder="Amt"
              onChange={(e) => setField("expenseEight", id, e.target.value)}
            />
          </InputGroup>
        </Form.Group>
      </td>
      <td>
        <Form.Group>
          <InputGroup size="sm">
            <InputGroup.Text className="expensesTableInputGroup">
              £
            </InputGroup.Text>
            <Form.Control
              type="number"
              step="any"
              className="expensesTableInput"
              value={row.expenseNine === 0 ? undefined : row.expenseNine}
              placeholder="Amt"
              onChange={(e) => setField("expenseNine", id, e.target.value)}
            />
          </InputGroup>
        </Form.Group>
      </td>
      <td>
        <Form.Group>
          <InputGroup size="sm">
            <InputGroup.Text className="expensesTableInputGroup">
              £
            </InputGroup.Text>
            <Form.Control
              type="number"
              step="any"
              className="expensesTableInput"
              value={row.expenseTen === 0 ? undefined : row.expenseTen}
              placeholder="Amt"
              onChange={(e) => setField("expenseTen", id, e.target.value)}
            />
          </InputGroup>
        </Form.Group>
      </td>
      <td>
        <Form.Group>
          <InputGroup size="sm">
            <InputGroup.Text className="expensesTableInputGroup">
              £
            </InputGroup.Text>
            <Form.Control
              type="number"
              step="any"
              className="expensesTableInput"
              value={row.expenseEleven === 0 ? undefined : row.expenseEleven}
              placeholder="Amt"
              onChange={(e) => setField("expenseEleven", id, e.target.value)}
            />
          </InputGroup>
        </Form.Group>
      </td>
      <td>
        <Form.Group>
          <InputGroup size="sm">
            <InputGroup.Text className="expensesTableInputGroup">
              £
            </InputGroup.Text>
            <Form.Control
              type="number"
              step="any"
              className="expensesTableInput"
              value={row.expenseTwelve === 0 ? undefined : row.expenseTwelve}
              placeholder="Amt"
              onChange={(e) => setField("expenseTwelve", id, e.target.value)}
            />
          </InputGroup>
        </Form.Group>
      </td>
      <td className="hideBorders col-1">
        {show && (
          <Button
            onClick={() => removeRow(id)}
            type="button"
            className="expensesNavcolour me-3"
          >
            <FontAwesomeIcon className="black" icon={faTrash} />
          </Button>
        )}

        {!show && (
          <Button
            onClick={() => removeRow(id)}
            type="button"
            className="expensesNavcolour"
          >
            <FontAwesomeIcon className="black" icon={faTrash} />
          </Button>
        )}

        {show && (
          <Button
            onClick={() => {
              addRow(id);
              setShow(false);
            }}
            type="button"
            className="expensesNavcolour"
          >
            <FontAwesomeIcon className="black" icon={faPlus} />
          </Button>
        )}
      </td>
    </tr>
  );
}
